import { Slide, toast } from "react-toastify";

// Common configuration for all notifications
const defaultConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
  transition: Slide,
  style: {
    backgroundColor: "#6600CC",
    color: "white",
    borderRadius: "10px",
    padding: "10px",
    fontSize: "14px",
  },
};

// Create notification functions
export const SuccessNotification = (message, customConfig = {}) => {
  toast.success(message, { ...defaultConfig, ...customConfig });
};

export const ErrorNotification = (message, customConfig = {}) => {
  toast.error(message, { ...defaultConfig, ...customConfig });
};

// Add more types for consistency
export const InfoNotification = (message, customConfig = {}) => {
  toast.info(message, { ...defaultConfig, ...customConfig });
};

export const WarningNotification = (message, customConfig = {}) => {
  toast.warning(message, { ...defaultConfig, ...customConfig });
};

// Override the default window.alert
const originalAlert = window.alert;
window.alert = (message) => {
  InfoNotification(message);
};

// Export the original alert in case it's needed
export const originalAlertFunction = originalAlert;
